import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { TemplatePreview } from './TemplatePreview';

const PreviewWrapper = styled.div<{
  transformScale: number;
  previewWidth: number;
  previewHeight: number;
}>`
  ${({ previewHeight, previewWidth, transformScale }) => `
    width: ${pxToRem(previewWidth * transformScale)};
    height: ${pxToRem(previewHeight * transformScale)};
  `};
  overflow: hidden;
  
  iframe {
    width: ${({ previewWidth }) => pxToRem(previewWidth)};
    height: ${({ previewHeight }) => pxToRem(previewHeight)};
    transform: scale(${({ transformScale }) => transformScale});
    transform-origin: top left;
  }
`;

type MobilePreviewProps = {
  messageMedium: string;
  templateId: number;
  /** Max width of the preview container to scale to */
  maxWidth?: number;
  /** Width of the inner preview iframe */
  previewWidth: number;
  /** Height of the inner preview iframe */
  previewHeight: number;
};

export const MobilePreview = ({
  templateId,
  messageMedium,
  maxWidth,
  previewWidth,
  previewHeight,
  ...props
}: MobilePreviewProps) => {
  const scale = maxWidth ? Number((maxWidth / previewWidth).toFixed(2)) : 1;
  return (
    <PreviewWrapper
      transformScale={scale}
      previewWidth={previewWidth}
      previewHeight={previewHeight}
      {...props}
    >
      <TemplatePreview messageMedium={messageMedium} templateId={templateId} />
    </PreviewWrapper>
  );
};
